import React, { ReactNode } from "react";

import "./paymentMethods.scss";

interface PaymentMethodsProps {
  children?: ReactNode;
}

const PaymentMethods: React.FC<PaymentMethodsProps> = ({ children = null }) => (
  <div className="payment-methods">
    {children}
  </div>
);

export default PaymentMethods;
